var _ellipse, _rect, _g, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _circle, _circle2, _g2, _ellipse2, _ellipse3, _rect17, _path2, _path3, _path4, _rect18, _g3, _rect19, _rect20, _path5, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _circle3, _circle4, _g4, _ellipse4, _ellipse5, _rect34, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchStatePlaceholder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 117,
    viewBox: "0 0 171 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.8859,
    cy: 58.0295,
    rx: 62.942,
    ry: 58.0295,
    fill: "#F3F3F3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 161.5,
    height: 42.9848,
    transform: "translate(0.75 11.6674)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_38261_114182)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 11.6674,
    width: 161.5,
    height: 39.9144,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 12.1674,
    width: 160.5,
    height: 38.9144,
    rx: 3.5,
    stroke: "#D1D1D1"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9629,
    y: 23.9487,
    width: 27.6331,
    height: 3.68441,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9629,
    y: 30.7035,
    width: 19.6502,
    height: 3.68441,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.779 15.9658L104.835 19.0128L107.891 15.9658L108.826 16.8988L104.835 20.8784L100.843 16.8988L101.779 15.9658Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9629,
    y: 37.4583,
    width: 14.1236,
    height: 3.68441,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.189,
    y: 23.3347,
    width: 9.51789,
    height: 1.91042,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.189,
    y: 27.1556,
    width: 17.7071,
    height: 1.91042,
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11.189,
    y: 38.6183,
    width: 17.7071,
    height: 1.91042,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 11.189,
    y: 30.9762,
    width: 11.4215,
    height: 1.91042,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 11.189,
    y: 34.7974,
    width: 11.4215,
    height: 1.91042,
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 11.189,
    y: 38.6183,
    width: 9.51789,
    height: 1.91042,
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 11.189,
    y: 40.5286,
    width: 17.1938,
    height: 1.90358,
    transform: "rotate(-90 11.189 40.5286)",
    fill: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 14.9961,
    y: 40.5286,
    width: 17.1938,
    height: 1.90358,
    transform: "rotate(-90 14.9961 40.5286)",
    fill: "black"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 18.8032,
    y: 40.5286,
    width: 17.1938,
    height: 1.90358,
    transform: "rotate(-90 18.8032 40.5286)",
    fill: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3213,
    y: 40.5286,
    width: 13.373,
    height: 1.90358,
    transform: "rotate(-90 28.3213 40.5286)",
    fill: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5142,
    y: 30.9762,
    width: 1.90358,
    height: 1.91042,
    fill: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5142,
    y: 34.7974,
    width: 1.90358,
    height: 1.91042,
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 139.529,
    cy: 32.5457,
    r: 12.2814,
    fill: "#D4E8EC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38261_114182",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: 20,
    width: 25,
    height: 25
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.529,
    cy: 32.5457,
    r: 12.2814,
    fill: "#D4E8EB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38261_114182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.256 38.6863C151.654 39.0811 151.47 40.9033 151.164 43.5342C150.859 46.1651 146.24 48.9474 142.842 48.5526C142.215 48.4798 137.392 48.056 136.839 47.8551C134.388 46.9662 133.704 49.09 135.32 44.2421C135.56 42.1825 137.088 40.046 139.529 39.6559C141.97 39.2657 144.377 37.7167 148.256 38.6863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.199 42.4219C140.734 41.7633 140.905 39.9299 141.174 39.0955C141.91 37.7656 143.458 35.2206 143.765 35.6799C144.148 36.2539 146.65 38.248 146.525 39.8523C146.325 42.4219 144.032 43.2452 142.199 42.4219Z",
    fill: "#FFD4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.57 36.1334C145.57 39.3148 142.991 41.8938 139.809 41.8938C136.628 41.8938 134.049 39.3148 134.049 36.1334C134.049 35.5468 133.886 31.0467 134.049 30.5134C134.77 28.1546 137.496 27.282 140.09 27.282C142.581 27.282 144.421 30.1271 145.225 32.3399C145.448 32.9537 145.57 35.4426 145.57 36.1334Z",
    fill: "#FFDBC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.158 35.7092C146.158 38.8906 143.579 41.4696 140.398 41.4696C137.216 41.4696 134.637 38.8906 134.637 35.7092C134.637 35.1226 134.474 30.6225 134.637 30.0892C135.358 27.7304 138.084 26.8578 140.679 26.8578C143.169 26.8578 145.01 29.7029 145.814 31.9157C146.037 32.5295 146.158 35.0184 146.158 35.7092Z",
    fill: "#FBC49C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.608 34.3878C138.301 34.6949 137.975 36.4412 138.301 37.1511C138.628 37.861 139.529 38.0722 140.299 37.6789",
    stroke: "#E29C69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.836 39.6073C141.371 40.5285 143.214 38.9933 142.906 37.7652",
    stroke: "#B85757",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 136.459,
    cy: 35.0019,
    rx: 0.614075,
    ry: 0.614068,
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 136.042,
    cy: 33.1812,
    rx: 1.39141,
    ry: 0.542148,
    transform: "rotate(3.90777 136.042 33.1812)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.77,
    cy: 32.2206,
    rx: 1.12398,
    ry: 0.532896,
    transform: "rotate(-21.1896 140.77 32.2206)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.758,
    cy: 33.7739,
    rx: 0.614075,
    ry: 0.614068,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.035 33.5151C134.035 31.3798 134.47 31.5607 134.358 30.9296C132.805 28.6673 132.592 29.4723 132.419 30.9296C132.273 32.1588 132.347 35.8228 133.389 37.0704C134.222 38.0684 134.302 38.7533 134.681 38.6863C134.352 37.4863 134.035 34.438 134.035 33.5151Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.631 31.653C144.52 30.6476 143.664 29.4515 143.25 28.9791C144.031 29.0338 145.802 29.3462 146.636 30.1584C147.678 31.1736 148.095 33.5306 147.193 35.1855C146.472 36.5095 145.271 36.9537 144.761 37.0103C144.764 35.6435 144.743 32.6584 144.631 31.653Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.7 33.8385C143.731 29.637 142.722 29.2242 140.499 29.637C136.944 30.297 136.146 31.4363 133.977 31.7779C132.161 32.0639 130.945 31.3582 130.318 30.3963C129.787 29.5818 130.216 28.4025 131.707 28.5683C130.925 27.5016 130.341 26.1056 132.161 26.712C135.538 26.712 137.063 26.2458 138.608 25.7909C140.192 25.3249 143.537 23.9117 145.363 26.712C145.749 27.304 145.877 27.7439 145.805 28.0691C148.744 31.2301 146.866 35.042 144.7 33.8385Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.082 34.3877C133.67 34.1792 134.31 34.337 134.31 35.6159C134.31 36.8947 134.705 38.1719 134.509 38.0676C134.264 37.9373 133.284 37.6767 132.957 36.8947C132.631 36.1128 132.347 34.6484 133.082 34.3877Z",
    fill: "#FBC49C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.84 31.9646C144.829 31.7399 144.201 32.714 144.014 33.2291C143.873 34.1658 143.677 36.011 144.014 35.8986C144.435 35.7581 146.121 35.4771 146.683 34.6341C147.245 33.7911 147.105 32.2456 145.84 31.9646Z",
    fill: "#FBC49C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.26 33.5921C146.04 32.9424 145.121 32.9342 144.906 33.3691",
    stroke: "#CA9A77",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.002 35.6158C133.695 35.6158 133.538 35.7134 133.388 35.9229",
    stroke: "#CA9A77",
    strokeLinecap: "round"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 136.459,
    cy: 38.0723,
    rx: 0.614067,
    ry: 0.614068,
    fill: "#EC8969"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.214,
    cy: 36.23,
    rx: 0.614067,
    ry: 0.614068,
    fill: "#EC8969"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 85.4912,
    y: 23.9487,
    width: 28.8612,
    height: 8.59696,
    rx: 4.29848,
    fill: "#729CDA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7896 27.019H96.5443V27.6331H89.7896V27.019Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.685 27.019H99.6147V27.6331H102.685V27.019Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.403 27.019L108.519 28.9234L110.634 27.019L111.282 27.6022L108.519 30.0894L105.755 27.6022L106.403 27.019Z",
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 161.5,
    height: 42.9848,
    transform: "translate(0.75 61)",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_38261_114182)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 61,
    width: 161.5,
    height: 39.9144,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 61.5,
    width: 160.5,
    height: 38.9144,
    rx: 3.5,
    stroke: "#D1D1D1"
  }))), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9629,
    y: 73.2814,
    width: 27.6331,
    height: 3.68441,
    fill: "#D9D9D9"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9629,
    y: 80.0361,
    width: 19.6502,
    height: 3.68441,
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.779 65.2985L104.835 68.3455L107.891 65.2985L108.826 66.2315L104.835 70.211L100.843 66.2315L101.779 65.2985Z",
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9629,
    y: 86.7909,
    width: 14.1236,
    height: 3.68441,
    fill: "#D9D9D9"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 11.189,
    y: 72.6674,
    width: 9.51789,
    height: 1.91042,
    fill: "black"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 11.189,
    y: 76.4883,
    width: 17.7071,
    height: 1.91042,
    fill: "black"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 11.189,
    y: 87.9509,
    width: 17.7071,
    height: 1.91042,
    fill: "black"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 11.189,
    y: 80.3088,
    width: 11.4215,
    height: 1.91042,
    fill: "black"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 11.189,
    y: 84.13,
    width: 11.4215,
    height: 1.91042,
    fill: "black"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 11.189,
    y: 87.9509,
    width: 9.51789,
    height: 1.91042,
    fill: "black"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 11.189,
    y: 89.8612,
    width: 17.1938,
    height: 1.90358,
    transform: "rotate(-90 11.189 89.8612)",
    fill: "black"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 14.9961,
    y: 89.8612,
    width: 17.1938,
    height: 1.90358,
    transform: "rotate(-90 14.9961 89.8612)",
    fill: "black"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 18.8032,
    y: 89.8612,
    width: 17.1938,
    height: 1.90358,
    transform: "rotate(-90 18.8032 89.8612)",
    fill: "black"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3213,
    y: 89.8612,
    width: 13.373,
    height: 1.90358,
    transform: "rotate(-90 28.3213 89.8612)",
    fill: "black"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5142,
    y: 80.3088,
    width: 1.90358,
    height: 1.91042,
    fill: "black"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5142,
    y: 84.13,
    width: 1.90358,
    height: 1.91042,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.529,
    cy: 81.8783,
    r: 12.2814,
    fill: "#EFD0DB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_38261_114182",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: 69,
    width: 25,
    height: 26
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.529,
    cy: 81.8783,
    r: 12.2814,
    fill: "#D4E8EB"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_38261_114182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.256 88.0189C151.654 88.4138 151.47 90.2359 151.164 92.8668C150.859 95.4978 146.24 98.28 142.842 97.8852C142.215 97.8124 137.392 97.3887 136.839 97.1877C134.388 96.2988 133.704 98.4227 135.32 93.5748C135.56 91.5151 137.088 89.3786 139.529 88.9885C141.97 88.5984 144.377 87.0493 148.256 88.0189Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.199 91.7546C140.734 91.0959 140.905 89.2625 141.174 88.4281C141.91 87.0982 143.458 84.5533 143.765 85.0125C144.148 85.5866 146.65 87.5806 146.525 89.185C146.325 91.7546 144.032 92.5779 142.199 91.7546Z",
    fill: "#FFD4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.57 85.466C145.57 88.6474 142.991 91.2264 139.809 91.2264C136.628 91.2264 134.049 88.6474 134.049 85.466C134.049 84.8794 133.886 80.3793 134.049 79.8461C134.77 77.4873 137.496 76.6146 140.09 76.6146C142.581 76.6146 144.421 79.4597 145.225 81.6726C145.448 82.2863 145.57 84.7752 145.57 85.466Z",
    fill: "#FFDBC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.158 85.0418C146.158 88.2232 143.579 90.8022 140.398 90.8022C137.216 90.8022 134.637 88.2232 134.637 85.0418C134.637 84.4552 134.474 79.9551 134.637 79.4219C135.358 77.0631 138.084 76.1904 140.679 76.1904C143.169 76.1904 145.01 79.0355 145.814 81.2484C146.037 81.8621 146.158 84.351 146.158 85.0418Z",
    fill: "#FBC49C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.608 83.7205C138.301 84.0275 137.975 85.7739 138.301 86.4838C138.628 87.1937 139.529 87.4049 140.299 87.0115",
    stroke: "#E29C69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.836 88.94C141.371 89.8612 143.214 88.326 142.906 87.0978",
    stroke: "#B85757",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 136.459,
    cy: 84.3345,
    rx: 0.614075,
    ry: 0.614068,
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 136.042,
    cy: 82.5139,
    rx: 1.39141,
    ry: 0.542148,
    transform: "rotate(3.90777 136.042 82.5139)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.77,
    cy: 81.5532,
    rx: 1.12398,
    ry: 0.532896,
    transform: "rotate(-21.1896 140.77 81.5532)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.758,
    cy: 83.1065,
    rx: 0.614075,
    ry: 0.614068,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.035 82.8478C134.035 80.7125 134.47 80.8933 134.358 80.2622C132.805 77.9999 132.592 78.805 132.419 80.2622C132.273 81.4915 132.347 85.1554 133.389 86.403C134.222 87.4011 134.302 88.086 134.681 88.0189C134.352 86.8189 134.035 83.7706 134.035 82.8478Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.631 80.9856C144.52 79.9802 143.664 78.7841 143.25 78.3117C144.031 78.3664 145.802 78.6789 146.636 79.4911C147.678 80.5063 148.095 82.8632 147.193 84.5182C146.472 85.8421 145.271 86.2864 144.761 86.343C144.764 84.9761 144.743 81.9911 144.631 80.9856Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.7 83.1712C143.731 78.9697 142.722 78.5569 140.499 78.9697C136.944 79.6297 136.146 80.769 133.977 81.1106C132.161 81.3966 130.945 80.6908 130.318 79.729C129.787 78.9144 130.216 77.7352 131.707 77.901C130.925 76.8343 130.341 75.4382 132.161 76.0446C135.538 76.0446 137.063 75.5785 138.608 75.1236C140.192 74.6575 143.537 73.2443 145.363 76.0446C145.749 76.6367 145.877 77.0766 145.805 77.4017C148.744 80.5628 146.866 84.3747 144.7 83.1712Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.082 83.7204C133.67 83.5119 134.31 83.6696 134.31 84.9485C134.31 86.2274 134.705 87.5045 134.509 87.4003C134.264 87.27 133.284 87.0093 132.957 86.2274C132.631 85.4454 132.347 83.981 133.082 83.7204Z",
    fill: "#FBC49C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.84 81.2973C144.829 81.0725 144.201 82.0466 144.014 82.5618C143.873 83.4984 143.677 85.3436 144.014 85.2312C144.435 85.0907 146.121 84.8098 146.683 83.9668C147.245 83.1238 147.105 81.5783 145.84 81.2973Z",
    fill: "#FBC49C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.26 82.9248C146.04 82.2751 145.121 82.2668 144.906 82.7017",
    stroke: "#CA9A77",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.002 84.9485C133.695 84.9485 133.538 85.046 133.388 85.2555",
    stroke: "#CA9A77",
    strokeLinecap: "round"
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 136.459,
    cy: 87.405,
    rx: 0.614067,
    ry: 0.614068,
    fill: "#EC8969"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.214,
    cy: 85.5628,
    rx: 0.614067,
    ry: 0.614068,
    fill: "#EC8969"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 85.4912,
    y: 73.2814,
    width: 28.8612,
    height: 8.59696,
    rx: 4.29848,
    fill: "#729CDA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7896 76.3517H96.5443V76.9658H89.7896V76.3517Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.685 76.3517H99.6147V76.9658H102.685V76.3517Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.403 76.3517L108.519 78.2561L110.634 76.3517L111.282 76.9348L108.519 79.422L105.755 76.9348L106.403 76.3517Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_38261_114182",
    x: 0.75,
    y: 11.6674,
    width: 169.5,
    height: 47.9144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_38261_114182"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_38261_114182",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_38261_114182",
    x: 0.75,
    y: 61,
    width: 169.5,
    height: 47.9144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_38261_114182"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_38261_114182",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchStatePlaceholder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search-state-placeholder.19dc4bfcec51a66a43d22bec741bfed5.svg";